export const Variables ={

  API_URL: "https://api.gazellebyrasha.com/api/",
  API_PUBLISHED: "https://api.gazellebyrasha.com/Uploads/",
};
